var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIbmRequestQuote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.75 17.5V13.75H15V17.5C15 17.8315 14.8683 18.1495 14.6339 18.3839C14.3995 18.6183 14.0815 18.75 13.75 18.75H3.75C3.41848 18.75 3.10054 18.6183 2.86612 18.3839C2.6317 18.1495 2.5 17.8315 2.5 17.5V2.5C2.5 2.16848 2.6317 1.85054 2.86612 1.61612C3.10054 1.3817 3.41848 1.25 3.75 1.25H10V2.5H3.75V17.5H13.75ZM16.4 1.53738L18.4625 3.59988H18.4563C18.6395 3.78681 18.7421 4.03813 18.7421 4.29988C18.7421 4.56164 18.6395 4.81295 18.4563 4.99988L9.70625 13.7499H6.25V10.2874L15 1.53738C15.1869 1.35416 15.4382 1.25153 15.7 1.25153C15.9618 1.25153 16.2131 1.35416 16.4 1.53738ZM7.5 12.4999H9.1875L15.0938 6.59988L13.4 4.90613L7.5 10.8124V12.4999ZM14.2812 4.02488L15.975 5.71863L17.3938 4.29988L15.7 2.60613L14.2812 4.02488Z",
    fill: "#343A40"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIbmRequestQuote);
export default __webpack_public_path__ + "static/media/IBMRequestQuote.8fbc49d2.svg";
export { ForwardRef as ReactComponent };